import { render, staticRenderFns } from "./FundingCompetitionsIndex.vue?vue&type=template&id=4cb08ab8&"
import script from "./FundingCompetitionsIndex.vue?vue&type=script&lang=js&"
export * from "./FundingCompetitionsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports